/**
 * @file
 * Scripts that hide and show popup search menu.
 */

// TODO: Add something sane to menu item selector
let $searchButton = $('.header-nav-commerce .menu .menu-link-item-', context);
let $searchBlock = $('.search-popup-block', context);
let $body = $('body', context);

$searchButton.once('search-popup-open').each(function() {
  $(this).click(function(event) {
    event.preventDefault();
    openPopup();
  });
});

$searchBlock.once('search-popup-close').each(function() {
  let $this = $(this);
  let $input = $this.find('#search-autocomplete');
  let $clear = $this.find('.button-clear');

  // Close button.
  $this.find('.close-button').click(function(event) {
    event.preventDefault();
    closePopup($this);
  });

  // Close on escape.
  document.onkeydown = function(event) {
    event = event || window.event;
    if ($this.hasClass('is-active') && event.keyCode === 27) {
      closePopup($this);
    }
  };

  $input.keypress(function() {
    $clear.show();
  });

  $input.focus(function() {
    if (!$(this).val()) {
      $clear.hide();
    }
  });

  $clear.click(function(event) {
    event.preventDefault();
    $(this).hide();
    $input.val('');
  });
});

function openPopup() {
  $('.search-popup-block').addClass('is-active');
  $body.addClass('is-fixed');
  setTimeout(function() {
    $searchBlock.find('input[type=search]').focus();
  }, 500);
}

function closePopup($el) {
  $el.addClass('is-closing');
  $body.removeClass('is-fixed');
  setTimeout(function() {
    $el.removeClass('is-closing is-active');
  }, 500);
}
